/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IndustryGroupWithProfiles } from '../../models/industry-group-with-profiles';

export interface ListIndustryGroupsWithProfiles$Params {
  maxProfiles?: number;
}

export function listIndustryGroupsWithProfiles(http: HttpClient, rootUrl: string, params?: ListIndustryGroupsWithProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IndustryGroupWithProfiles>>> {
  const rb = new RequestBuilder(rootUrl, listIndustryGroupsWithProfiles.PATH, 'get');
  if (params) {
    rb.query('maxProfiles', params.maxProfiles, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<IndustryGroupWithProfiles>>;
    })
  );
}

listIndustryGroupsWithProfiles.PATH = '/rest/profile/rank/industry-group';
